/**
 * `/cabinet/login` — короткая ссылка из письма контрагенту. Своего экрана у входа в кабинет
 * больше нет: вход один на оба контура (`app/login.tsx`), переключатель «Сотрудник |
 * Бизнес-партнёр» выбирает realm. Здесь остался редирект, чтобы ссылки из писем и закладки
 * не стали битыми.
 */
import { Redirect } from 'expo-router'
import { Text, YStack } from 'tamagui'

import { cabinetEnabled } from '../../src/auth/config'
import { useApp } from '../../src/i18n'
import { tone } from '../../src/theme/tones'

export default function CabinetLoginScreen() {
  const { l } = useApp()

  // Кабинет не настроен в сборке — вести на корпоративный вход бессмысленно: вкладки партнёра
  // там нет, и внешний упёрся бы в форму, которая его realm не знает.
  if (!cabinetEnabled) {
    return (
      <YStack flex={1} alignItems="center" justifyContent="center" padding={24} backgroundColor="$bgLayout">
        <Text fontSize={13} color={tone('red').text} maxWidth={420} textAlign="center">
          {l('cab.login.disabled')}
        </Text>
      </YStack>
    )
  }

  return <Redirect href="/login?tab=partner" />
}
